var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AModal",
    {
      staticClass: "person-modal",
      attrs: { size: "lg", "disable-portaling": "" },
      model: {
        value: _vm.valueComputed,
        callback: function ($$v) {
          _vm.valueComputed = $$v
        },
        expression: "valueComputed",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "person-modal-header",
          class: _vm.modalHasBackgroundImage,
        },
        [_c("div", { staticClass: "person-modal-header-content" })]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "profile-image-container" },
        [
          _c("AImage", {
            attrs: {
              img: _vm.image,
              "placeholder-url": require("assets/image-placeholders/person-placeholder.svg"),
              ratio: "1-1",
              preset: "peoplegroupperson",
              cover: "",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "speaker-modal-content" }, [
        _c("div", { staticClass: "person-info" }, [
          _c("h2", [_vm._v(_vm._s(_vm.name) + " ")]),
          _vm._v(" "),
          _c("div", { staticClass: "position" }, [
            _vm._v("\n        " + _vm._s(_vm.position) + "\n        "),
            _vm.position && _vm.organisation
              ? _c("span", [_vm._v(",")])
              : _vm._e(),
            _vm._v("\n        " + _vm._s(_vm.organisation) + "\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "person-description",
          domProps: { innerHTML: _vm._s(_vm.description) },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "person-contact" }, [
          _c("ul", { staticClass: "person-contact-list" }, [
            _vm.contactPhone
              ? _c("li", { staticClass: "person-contact-list-item" }, [
                  _c("a", { attrs: { href: `tel:${_vm.contactPhone}` } }, [
                    _c(
                      "span",
                      { staticClass: "contact-icon" },
                      [_c("font-awesome-icon", { attrs: { icon: "mobile" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.contactPhone) + " ")]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.contactUrl
              ? _c("li", { staticClass: "person-contact-list-item" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.$options.filters.toUrl(_vm.contactUrl),
                        target: "_blank",
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "contact-icon" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "comment" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Contact " + _vm._s(_vm.name) + " ")]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }